<template>
    <!-- <div class="text-box" v-html="headerHtml" v-on:touchstart="customTouchStart" v-on:touchend="customTouchEnd"></div> -->
    <!-- <div id="header_box" class="text-box" :v-bind:on-touchend="test"> -->
    <div class="display_flex color_gray_900" style="height: calc(100% - 1.99vmin)">
        <div class="highlight">
            <!-- <q-btn round outline :style="`color: ${isPenMode ? 'black' : 'lightgrey'};`" -->
            <!-- <q-btn round unelevated
                :style="`color: ${isPenMode ? 'black' : 'lightgrey'}; ${penTooltip ? 'border: 5px solid #FEFA53' : 'border: 1px solid #123'}`"
                :onclick="() => { isPenMode = !isPenMode; penTooltip = false; }"> -->
            <q-btn
                round
                unelevated
                :style="`isPenMode? color: ${isPenMode ? 'black' : 'lightgrey'}; ${penTooltip ? 'border: 5px solid #FEFA53' : 'border: 1px solid #123'}`"
                :onclick="
                    () => {
                        isPenMode = !isPenMode;
                        penTooltip = false;
                    }
                "
            >
                <q-icon v-show="isPenMode" name="img:/assets/images/icon/icon_pen.svg" />
                <q-icon v-show="!isPenMode" name="img:/assets/images/icon/icon_pen_off.svg" />
                <q-tooltip v-if="penTooltipVisible" class="pen-tooltip tooltip__txt" anchor="center right" self="center left" v-model="penTooltip" transition-show="jump-right" transition-hide="jump-left">
                    핵심어와 중심 문장의 핵심 내용에 밑줄을 그으며 읽으세요.
                </q-tooltip>
            </q-btn>
            <q-btn round outline :style="`color: ${isViewMode ? 'black' : 'lightgrey'};`" :onclick="onEYE">
                <q-icon v-show="isViewMode" name="img:/assets/images/icon/icon_view.svg" />
                <q-icon v-show="!isViewMode" name="img:/assets/images/icon/icon_view_off.svg" />
            </q-btn>
        </div>
        <div class="pd_left_24 passage__content">
            <q-scroll-area ref="scrollAreaRef" visible style="height: 100%" class="passage__scroll">
                <q-chip v-if="bookNm?.includes('수능') || bookNm?.includes('교과') || bookNm?.includes('모의')">{{ bookNm }}</q-chip>

                <!-- KRT-2096 하이라이트 기능 고도화 -->
                <div id="header_box" class="text-box" :class="`${!isViewMode ? 'off-highlight-view' : isPenMode ? 'highlighted' : 'highlighted-none'}`" v-html="headerHtml" ref="highlightRef"></div>

                <!-- <div id="header_box" class="text-box" :class="`${isViewMode ? 'highlighted' : 'highlighted-none'}`" v-html="headerHtml"></div> -->
                <p v-if="headerHtml" v-scroll-fire="readEnd">&nbsp;</p>
            </q-scroll-area>
        </div>
        <div v-if="isHighlighting" :style="highlighitingStyle">
            {{ highlighitingTag }}
        </div>
    </div>

    <q-menu
        touch-position
        :target="menuShow"
        @before-hide="
            () => {
                menuShow = false;
            }
        "
    >
        <q-list style="min-width: 100px">
            <q-item clickable v-close-popup :onclick="deleteMark">
                <q-item-section>
                    <p class="display_flex">
                        <span style="width: 20px; height: 20px; margin-right: 6px; background-color: yellow; border-radius: 50%" />
                        <span class="highlight_del">하이라이팅 삭제</span>
                    </p>
                </q-item-section>
            </q-item>
            <q-separator />
            <div v-for="n in inputIdx" :key="n">
                <q-item clickable v-close-popup :onclick="() => highlightToAnswer(n)">
                    <q-item-section>
                        <div class="display_flex">
                            <p style="width: 20px; height: 20px; margin-right: 6px; text-align: center">
                                <q-icon name="done" color="grey" />
                            </p>
                            <p>답 입력 {{ n }}번</p>
                        </div>
                    </q-item-section>
                </q-item>
                <q-separator />
            </div>
            <!-- <q-item clickable v-close-popup :onclick="highlightToAnswer">
                <q-item-section>답 입력(2번)</q-item-section>
            </q-item> -->
        </q-list>
    </q-menu>
    <!-- <div class="text-box disableTouch" v-html="headerHtml" @mouseup="test"></div> -->
</template>

<script setup>
import { onMounted, onUnmounted, ref, defineProps, watch, isProxy, toRaw, defineEmits } from 'vue';
import { useRoute } from 'vue-router';
import dataToParse from '@/helpers/qbankParser/dataParse';
import { styleTags } from '@/helpers/qbankParser/styleTags';
import { useQuasar } from 'quasar';
import { GlobalStore } from '@/store';
import moment from 'moment';
import { scroll } from 'quasar';

const { setVerticalScrollPosition, getVerticalScrollPosition, getScrollTarget } = scroll;

const headerHtml = ref('');
const menuShow = ref(false);
const isPenMode = ref(true);
const isViewMode = ref(true);
const inputIdx = ref(0);
const bookNm = ref('');
const penTooltip = ref(false);
const penTooltipVisible = ref(true);
const scrollAreaRef = ref(null);
const platform = ref('DESKTOP');

const highlighitingTag = ref('');
const lastRange = ref();
const isHighlighting = ref(false);

const highlighitingStyle = ref({
    position: 'absolute',
    display: 'flex',
    padding: '5px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.8)',
    color: 'white',
    // 다른 CSS 속성들...
});

// KRT-2096 하이라이트 기능 고도화
const highlightRef = ref(null);
const stateRef = ref({
    startTop: 0,
    startX: 0,
    startY: 0,
    dragging: false,
});

const $q = useQuasar();

const route = useRoute();

let currentMarkTarget = '';
let markId = 0;

const gStore = GlobalStore();
const emit = defineEmits(['stopNoti', 'setInputAnswer', 'isChangeHeader']);

const props = defineProps({
    questionHeader: {
        default: '',
    },
    inputIdx: {
        default: 0,
    },
    bookNm: {
        default: '',
    },
    reviewHeader: {
        default: null,
    },
    tooltipMsg: {
        default: true,
    },
    currentNo: { required: false },
    isINSPECT: { default: false },
});

// TODO: oncontextmenu 테스트 이후 제거
// window.oncontextmenu = function (event) {
//     event.preventDefault();
//     // event.stopPropagation();
//     // return false;
// };

const readEnd = () => {
    emit('stopNoti');
};

const reviewHeaderInit = () => {
    setTimeout(() => {
        const item = document.querySelectorAll('mark');
        let maxCnt = 0;
        item.forEach((i) => {
            maxCnt = Number(i.className.replace('mark_')) > maxCnt ? Number(i.className.replace('mark_')) : maxCnt;
        });
        markId = maxCnt;
        addMarkEvent();
    }, 500);
};

const scrollUp = () => {
    if (route.path === '/eval-test') {
        const el = document.querySelector('.q-scrollarea__content');
        setVerticalScrollPosition(getScrollTarget(el), 0, 0);
    }
    return;
};
watch(
    () => props.questionHeader,
    (newValue) => {
        // console.log('--questionHeader-newValue-', newValue);
        scrollUp();
        if (newValue) {
            bookNm.value = toRaw(props.bookNm);
            let questionHeader = toRaw(newValue);
            // reviewHeaderInit();
            headerHtml.value = questionHeader;

            changeHtmlString(questionHeader);

            // document.removeEventListener('touchstart', test);
            // document.addEventListener('touchstart', test);
            // if (gstore?.platform === 'DESKTOP') {
            //     document.getElementById('header_box').removeEventListener('mouseup ', test);
            //     document.getElementById('header_box').addEventListener('mouseup ', test);
            // } else {
            //     document.getElementById('header_box').removeEventListener('touchend', test);
            //     document.getElementById('header_box').addEventListener('touchend', test);
            // }

            // if (props.tooltipMsg) {
            //     penTooltip.value = true;
            //     setTimeout(() => {
            //         penTooltip.value = false;
            //     }, 2000)
            // }
        }
    },
);

watch(
    () => props.reviewHeader,
    (newValue) => {
        // console.log('--watch-props.reviewHeader-', newValue);
        bookNm.value = toRaw(props.bookNm);
        let questionHeader = toRaw(newValue);
        reviewHeaderInit();
        headerHtml.value = questionHeader;
        changeHtmlString(questionHeader);
        // document.removeEventListener('touchstart', test);
        // document.addEventListener('touchstart', test);
        // if (gstore?.platform === 'DESKTOP') {
        //     document.removeEventListener('touchstart ', test);
        //     document.addEventListener('touchstart ', test);
        //     // document.removeEventListener('touchstart', test);
        //     // document.addEventListener('touchstart', test);
        // } else {
        //     document.removeEventListener('touchend', test);
        //     document.addEventListener('touchend', test);
        // }

        // if (props.tooltipMsg) {
        //     penTooltip.value = true;
        //     setTimeout(() => {
        //         penTooltip.value = false;
        //     }, 2000)
        // }
    },
);

watch(
    () => props.inputIdx,
    (newValue) => {
        inputIdx.value = toRaw(newValue);
    },
);
watch(
    () => props.bookNm,
    (newValue) => {
        bookNm.value = toRaw(newValue);
    },
);

// watch(() => props.scrollUp, (newValue) => {
//     // bookNm.value = toRaw(newValue);
//     if (newValue !== 0) {
//         scrollAreaRef.value.setScrollPosition('vertical', 0, 300);
//     }
// })

//  쓸데없는 style 정리.
const changeHtmlString = (text) => {
    let _hSetence = text;
    if (text) {
        // console.log('- ------currentNo--', props.currentNo);
        // console.log('-초기값-questionHeader--', _hSetence);
        _hSetence = _hSetence.replace('<div style="font-size:14.3pt;">※</div><div style="font-size:14.3pt;"><strong> </strong></div>', ''); // 당구장 div 제거
        _hSetence = _hSetence.replace('<div style="font-size:15.6pt;">※</div><div style="font-size:15.6pt;"><strong> </strong></div>', ''); // 당구장 div 제거
        if (!_hSetence.includes('※[')) {
            _hSetence = _hSetence.replace('font-size:14.3pt;">다음', `font-size:14.3pt; font-weight:700;">※${props.currentNo || ''}다음`); // 번호_삽입1
            _hSetence = _hSetence.replace('font-size:15.6pt;">다음', `font-size:14.3pt; font-weight:700;">※${props.currentNo || ''}다음`); // 번호_삽입1
            _hSetence = _hSetence.replace('<div style="font-size:15.6pt;"><strong>※', `<div style="font-size:15.6pt;"><strong>※${props.currentNo || ''}`); // 번호_삽입2
        }
        // console.log('-수정완료-questionHeader--', _hSetence);
    }
    headerHtml.value = _hSetence;
};

// KRT-2096 하이라이트 기능 고도화
const TOUCHMOVE_DELAY_TIME = 20; // Call only once per ms
const throttle = (func, wait) => {
    let timeout;
    return function () {
        if (timeout) return;

        const args = arguments;
        const later = () => {
            timeout = null;
            func.apply(this, args);
        };
        timeout = setTimeout(later, wait);
    };
};

const dragStartHandler = (evt, state, el) => {
    state.startTop = highlightRef.value.getBoundingClientRect().top;
    state.startX = evt.touches ? evt.touches[0].clientX : evt.clientX;
    state.startY = evt.touches ? evt.touches[0].clientY : evt.clientY;
    state.dragging = true;

    el.addEventListener(
        'touchmove',
        throttle((evt) => draggingHandler(evt, state), TOUCHMOVE_DELAY_TIME),
    );
    el.addEventListener('touchend', () => dragEndHandler(state, el));
};

const draggingHandler = (evt, state) => {
    const currentTop = highlightRef.value.getBoundingClientRect().top;
    const isScrollMove = Math.abs(currentTop - state.startTop) > 20;
    const isScrollDown = state.startTop < currentTop;
    if (!state.dragging || isScrollMove || isScrollDown) return;

    const clientX = evt.touches ? evt.touches[0].clientX : evt.clientX;
    const clientY = evt.touches ? evt.touches[0].clientY : evt.clientY;
    const range1 = document.caretRangeFromPoint(state.startX, state.startY);
    const range2 = document.caretRangeFromPoint(clientX, clientY);
    if (range1 && range2) {
        const selection = document.getSelection();
        selection.removeAllRanges();
        const range3 = new Range();
        range3.setStart(range1.startContainer, range1.startOffset);
        range3.setEnd(range2.startContainer, range2.startOffset);
        selection.addRange(range3);
    }
};

const dragEndHandler = (state, el) => {
    state.dragging = false;

    isHighlighting.value = false;
    highlighitingTag.value = '';
    if (menuShow.value || !isPenMode.value || !isViewMode.value) return false;

    const selection = window.getSelection && window.getSelection();
    if (selection && selection.rangeCount > 0) {
        let markEl = null;
        const range = document.getSelection().getRangeAt(0);
        if (range.startContainer === range.endContainer) {
            if (range.startOffset !== range.endOffset) {
                markId += 1;
                markEl = document.createElement('mark');
                markEl.setAttribute('class', 'mark mark_' + markId);
                range.surroundContents(markEl);
                addMarkEvent();
                document.getSelection().removeAllRanges();
            }
        } else {
            let allranges = getSafeRanges(range, document);
            var duCheck = false;
            for (var i = 0; i < allranges.length; i++) {
                if (!duCheck) {
                    if (allranges[i].commonAncestorContainer.nodeName === 'MARK') {
                        duCheck = true;
                        break;
                    }
                }
            }

            if (duCheck) {
                $q.notify({
                    color: '#8E43F0',
                    textColor: 'white',
                    position: 'center',
                    timeout: 2000,
                    message: '하이라이트는 중복될 수 없습니다. 중복되는 하이라이트를 삭제해 주세요.',
                });
                document.getSelection().removeAllRanges();
            } else {
                markId += 1;
                for (let i = 0; i < allranges.length; i++) {
                    markEl = document.createElement('mark');
                    markEl.setAttribute('class', 'mark mark_' + markId);
                    allranges[i].surroundContents(markEl);
                    addMarkEvent();
                    document.getSelection().removeAllRanges();
                }
            }
        }
    }

    emit('isChangeHeader', true);

    el.removeEventListener('touchmove', (evt) => draggingHandler(evt, state));
    el.removeEventListener('touchend', () => dragEndHandler(state));
};

onMounted(() => {
    platform.value = gStore.platform ? gStore.platform : 'DESKTOP';
    let questionHeader = toRaw(props.questionHeader);

    if (props.reviewHeader) {
        questionHeader = toRaw(props.reviewHeader);
        reviewHeaderInit();
    }
    headerHtml.value = questionHeader;
    bookNm.value = toRaw(props.bookNm);
    changeHtmlString(questionHeader);

    // document.removeEventListener('touchstart', test);
    // document.addEventListener('touchstart', test);
    // if (gstore?.platform === 'DESKTOP') {
    //     // document.removeEventListener('touchstart', test);
    //     // document.addEventListener('touchstart', test);
    //     document.getElementById('header_box').removeEventListener('mouseup  ', test);
    //     document.getElementById('header_box').addEventListener('mouseup  ', test);
    // } else {
    //     document.getElementById('header_box').removeEventListener('touchend', test);
    //     document.getElementById('header_box').addEventListener('touchend', test);
    // }
    // document.oncontextmenu = function (e) {
    //     alert("오른쪽버튼을 이용할 수 없습니다...");
    //     return false;
    // }
    if (props.tooltipMsg && !props.isINSPECT) {
        setTimeout(() => {
            penTooltip.value = true;
            setTimeout(() => {
                penTooltip.value = false;
                penTooltipVisible.value = false;
            }, 3000);
        }, 500);
    }

    // KRT-2096 하이라이트 기능 고도화
    if ('ontouchstart' in window) {
        highlightRef.value.addEventListener('touchstart', (evt) => {
            dragStartHandler(evt, stateRef.value, highlightRef.value);
        });
    } else {
        highlightRef.value.addEventListener('mouseup', (evt) => {
            test(evt);
        });
    }
});

onUnmounted(() => {
    //
    headerHtml.value = '';
    penTooltip.value = false;
});

const onEYE = () => {
    isPenMode.value = !isPenMode.value;
    isViewMode.value = !isViewMode.value;
    document.getSelection().removeAllRanges();
};
const onMarkTooltipMark = (v) => {
    currentMarkTarget = v.target.classList;
    menuShow.value = true;
};
const deleteMark = () => {
    // const val = v.target.classList;
    const val = currentMarkTarget;
    const els = document.getElementsByClassName(`${val}`);
    // const els = (document.getElementsByClassName(`${'mark_' + val}`));
    //.remove(`${'.mark_' + val}`);
    for (var i = 0; i < els.length; i++) {
        els[i].after(els[i].textContent);
    }
    for (var i = els.length - 1; i > -1; i--) {
        els[i].remove();
    }
    currentMarkTarget = '';
};

const addMarkEvent = () => {
    const item = document.querySelectorAll('mark');
    item.forEach((target) => {
        if (gStore.platform === 'DESKTOP') {
            target.removeEventListener('click', onMarkTooltipMark);
            target.addEventListener('click', onMarkTooltipMark);
        } else {
            target.removeEventListener('touchstart', onMarkTooltipMark);
            target.addEventListener('touchstart', onMarkTooltipMark);
        }
        // target.removeEventListener('touchend', onMarkTooltipMark);
        // target.addEventListener('touchend', onMarkTooltipMark)
    });
};

const highlightToAnswer = (n) => {
    const val = currentMarkTarget;
    const els = document.getElementsByClassName(`${val}`);
    // const els = (document.getElementsByClassName(`${'mark_' + val}`));
    //.remove(`${'.mark_' + val}`);
    let tmpText = '';
    for (var i = 0; i < els.length; i++) {
        if (els[i].parentElement.className === `${val}`) {
            // console.log(els[i]);
        } else {
            // console.log(els[i]);
            tmpText += els[i].textContent;
        }
    }
    emit('setInputAnswer', n, tmpText);
};

let touchStartPos = null;
let startY;
const handleTouchStart = (event) => {
    const touch = event.touches[0];
    startY = touch.clientY; // touchstart event 발생시의 Y 좌표를 저장
    touchStartPos = { x: touch.clientX, y: touch.clientY };
};

const handleTouchMove = (event) => {
    // isHighlighting.value = true;
    // 드래그가 활성화된 경우에만 기본 브라우저 동작을 막습니다.
    // if (isPenMode || isViewMode) {
    //     event.preventDefault();
    // }

    if (touchStartPos) {
        const touch = event.touches[0];
        const range = document.caretRangeFromPoint(touch.clientX, touch.clientY);
        const startRange = document.caretRangeFromPoint(touchStartPos.x, touchStartPos.y);

        // Y 좌표가 처음 touchstart event 때의 Y 좌표와 얼마나 차이가 나는지 계산
        const deltaY = Math.abs(touch.clientY - startY);

        // Y 좌표의 차이가 특정 임계값(예: 10px)을 초과하면, 이벤트를 무시
        if (deltaY > 10) return;

        if (range && startRange) {
            const selection = document.getSelection();
            selection.removeAllRanges();
            const newRange = new Range();
            newRange.setStart(startRange.startContainer, startRange.startOffset);
            newRange.setEnd(range.startContainer, range.startOffset);
            selection.addRange(newRange);

            // if (lastRange.value && lastRange.value.startOffset !== range.startOffset) {
            //     const selectedText = selection.toString();
            //     highlighitingTag.value = highlighitingTag.value + selectedText.charAt(selectedText.length - 1);
            //     console.log(highlighitingTag.value);
            // }
            // lastRange.value = range;

            // // 위치 갱신
            // highlighitingStyle.value = {
            //     ...highlighitingStyle.value,

            //     left: `${touch.clientX}px`,
            //     top: `${touch.clientY - 120}px`, // 텍스트 높이에 따라 조절 필요
            // };
        }
    }
};

// const handleTouchEnd = () => {
//     const selection = document.getSelection();
//     if (selection.rangeCount > 0) {
//         const range = selection.getRangeAt(0);
//         if (range.startContainer !== range.endContainer || range.startOffset !== range.endOffset) {
//             test(range);
//         }
//     }
//     touchStartPos = null;
// };

const test = (e) => {
    // e.preventDefault();
    // alert('!!!!!!!!!!!!!!!!!!!!!!!!');
    // var newNode = document.createElement("strong");
    // newNode.setAttribute("class", "highlighted");
    // for (let node in range.commonAncestorContainer.childNodes) {
    // }
    // range.surroundContents(newNode);
    isHighlighting.value = false;
    highlighitingTag.value = '';
    if (menuShow.value || !isPenMode.value || !isViewMode.value) {
        return false;
    }
    // console.log('--getSelection getSelection--',document.getSelection())
    // console.log('--getSelection getSelection-getRangeAt-',document.getSelection().getRangeAt(0))
    var sel = window.getSelection && window.getSelection();
    if (sel && sel.rangeCount > 0) {
        // 0 index error  방지
        if ((document.getSelection() && document.getSelection().getRangeAt(0)) || gStore.platform === 'IOS') {
            var range = document.getSelection().getRangeAt(0);

            if (range.startContainer === range.endContainer) {
                if (range.startOffset !== range.endOffset) {
                    markId += 1;
                    // markId = moment().valueOf();
                    var highlightelement = document.createElement('mark');
                    highlightelement.setAttribute('class', 'mark mark_' + markId);
                    // highlightelement.addEventListener("click", function () {
                    //     deleteMark(markId);
                    // })
                    // highlightelement.onclick = () => { deleteMark(markId); };
                    range.surroundContents(highlightelement);
                    addMarkEvent();
                    document.getSelection().removeAllRanges();
                }
            } else {
                var allranges = getSafeRanges(range, document);
                var duCheck = false;
                for (var i = 0; i < allranges.length; i++) {
                    if (!duCheck) {
                        // if (allranges[i].commonAncestorContainer.innerHTML.indexOf('<mark') > -1 || allranges[i].commonAncestorContainer.innerHTML.indexOf('mark/>') > -1) {
                        if (allranges[i].commonAncestorContainer.nodeName === 'MARK') {
                            duCheck = true;
                            break;
                        }
                    }
                }

                // if ((document.getSelection().getRangeAt(0)?.commonAncestorContainer.innerHTML).indexOf('<mark') > -1 || (document.getSelection().getRangeAt(0)?.commonAncestorContainer.innerHTML).indexOf('mark/>') > -1) {
                if (duCheck) {
                    $q.notify({
                        color: '#8E43F0',
                        textColor: 'white',
                        position: 'center',
                        timeout: 2000,
                        // icon: 'cloud_done',
                        message: '하이라이트는 중복될 수 없습니다. 중복되는 하이라이트를 삭제해 주세요.',
                    });
                    document.getSelection().removeAllRanges();
                } else {
                    markId += 1;
                    // markId = moment().valueOf();
                    for (var i = 0; i < allranges.length; i++) {
                        var highlightelement = document.createElement('mark');
                        highlightelement.setAttribute('class', 'mark_' + markId);
                        // highlightelement.onclick = () => { deleteMark(markId); };
                        // highlightelement.addEventListener("click", function () {
                        //     deleteMark(markId);
                        // })
                        allranges[i].surroundContents(highlightelement);

                        addMarkEvent();
                        document.getSelection().removeAllRanges();
                    }
                }
            }
        }
    }
    emit('isChangeHeader', true);
};

// var selection = window.getSelection();
// var ranges = selection.getRangeAt(0);
// var allranges = getSafeRanges(ranges, document);
// for (var i = 0; i < allranges.length; i++) {
//     allranges[i].surroundContents(highlightelement);
// }
const getRangeOfMiddleElements = (topStartNode, topEndNode) => {
    let rangeArray = new Array(0);
    let element = topStartNode?.nextSibling;
    while (element && element != topEndNode) {
        rangeArray = rangeArray.concat(getRangeOfChildNodes(element));
        element = element.nextSibling;
    }

    return rangeArray;
};

const getRangeOfChildNodes = (node) => {
    var doc = document;
    var rangeArray = new Array(0);
    if (node.nodeType == Node.TEXT_NODE) {
        var xm = doc.createRange();
        xm.setStartBefore(node);
        xm.setEndAfter(node);
        rangeArray.push(xm);
    } else {
        for (var i = 0; i < node.childNodes.length; i++) {
            var childNode = node.childNodes[i];
            rangeArray = rangeArray.concat(getRangeOfChildNodes(childNode));
        }
    }
    return rangeArray;
};

const getSafeRanges = (range, currentDoc) => {
    var doc = currentDoc;
    var commonAncestorContainer = range.commonAncestorContainer;
    var startContainer = range.startContainer;
    var endContainer = range.endContainer;
    var startArray = new Array(0),
        startRange = new Array(0);
    var endArray = new Array(0),
        endRange = new Array(0);
    // @@@@@ If start container and end container is same
    if (startContainer == endContainer) {
        return [range];
    } else {
        for (var i = startContainer; i != commonAncestorContainer; i = i.parentNode) {
            startArray.push(i);
        }
        for (var i = endContainer; i != commonAncestorContainer; i = i.parentNode) {
            endArray.push(i);
        }
    }
    if (0 < startArray.length) {
        for (var i = 0; i < startArray.length; i++) {
            if (i) {
                var node = startArray[i - 1];
                while ((node = node.nextSibling) != null) {
                    startRange = startRange.concat(getRangeOfChildNodes(node));
                }
            } else {
                var xs = doc.createRange();
                var s = startArray[i];
                var offset = range.startOffset;
                var ea = startArray[i].nodeType == Node.TEXT_NODE ? startArray[i] : startArray[i].lastChild;
                if (ea) {
                    xs.setStart(s, offset);
                    xs.setEndAfter(ea);
                    startRange.push(xs);
                }
            }
        }
    }
    if (0 < endArray.length) {
        for (var i = 0; i < endArray.length; i++) {
            if (i) {
                var node = endArray[i - 1];
                while ((node = node.previousSibling) != null) {
                    endRange = endRange.concat(getRangeOfChildNodes(node));
                }
            } else {
                var xe = doc.createRange();
                var sb = endArray[i].nodeType == Node.TEXT_NODE ? endArray[i] : endArray[i].firstChild;
                var end = endArray[i];
                var offset = range.endOffset;

                if (sb) {
                    xe.setStartBefore(sb);
                    xe.setEnd(end, offset);
                    endRange.unshift(xe);
                }
            }
        }
    }
    var topStartNode = startArray[startArray.length - 1];
    var topEndNode = endArray[endArray.length - 1];
    var middleRange = getRangeOfMiddleElements(topStartNode, topEndNode);
    startRange = startRange.concat(middleRange);
    var response = startRange.concat(endRange);
    return response;
};
</script>

<style scoped lang="scss">
P {
    margin-bottom: 0;
    line-height: inherit;
}

.highlighted {
    ::-moz-selection {
        /* Code for Firefox */
        // color: red;
        background: yellow;
    }

    ::selection {
        // color: red;
        background: yellow;
    }

    ::v-deep mark {
        background-color: yellow;
        color: black;
    }
}

.highlighted-none {
    ::-moz-selection {
        /* Code for Firefox */
        // color: red;
        // background: yellow;
        background: yellow;
    }

    ::selection {
        // color: red;
        // background: white;
    }

    ::v-deep mark {
        background-color: yellow;
        color: black;
    }

    /* // touch-action: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none; */
}

.off-highlight-view {
}

.text-box :deep {
    div {
        -webkit-touch-callout: none;

        // font-size: size(16);
        img {
            position: relative;
            top: 4px;
        }

        p {
            //margin-bottom: 0px;
        }
    }
}

.text-box {
    // -webkit-touch-callout: none;
    // border: 1px solid;
    // padding: 10px;
}

.disableTouch {
    // touch-action: none;
    // pointer-events: none;
}

/* .border-title_box_top {
  border: #3c5a86 1px solid;


  // display: inline-flex;
  .border-title {
    font-size: 16px;
    position: relative;
    margin: auto;
    top: -14px;
    // margin-left: -20px;
    display: inline;
    background-color: white;
  }
}

.border-title_box_left {
  border: #3c5a86 1px solid;

  display: inline-flex;

  .border-title {
    font-size: 16px;
    position: relative;
    margin: auto;
    top: -8px;
    margin-left: -20px;
    margin-right: 10px;
    display: inline;
    background-color: white;
    height: fit-content;
  }
}

.border-title_box_right {
  border: #3c5a86 1px solid;

  display: inline-flex;

  .border-title {
    font-size: 16px;
    position: relative;
    margin: auto;
    top: -8px;
    margin-left: 10px;
    margin-right: -20px;
    display: inline;
    background-color: white;
    height: fit-content;
  }
} */

::v-deep {
    .highlight {
        width: 3.5vw;
        margin-left: 2.5vmin;

        button {
            width: 3.5vw;
            height: 3.5vw;

            &:nth-of-type(n + 2) {
                margin-top: 2.5vmin;
            }

            .q-icon {
                font-size: 2.05vw;
            }
        }
    }

    .q-scrollarea__container {
        max-width: 1540px;
        margin: 0 auto;
    }

    .q-scrollarea__content {
        padding-bottom: 3.33vmin;
    }

    .q-scrollarea__bar--v,
    .q-scrollarea__thumb--v {
        width: 0.3vw;
    }
}

.passage {
    &__content {
        width: calc(100% - 40px);
        height: 100%;
        padding-right: 1vmin;
    }

    &__scroll {
        padding-right: 2.33vmin;
        // padding-bottom: 3.33vmin;
    }
}
</style>
